import { isArray, isObjectLike, isPlainObject, map, transform, set, camelCase } from 'lodash';
import { Dictionary } from 'link-parent-bin';

export function camelize<T extends object>(obj: object): T | object {
    if (isPlainObject(obj)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return transform(<Dictionary> obj, (result, value: any, key) =>
            set(result, camelCase(key), isObjectLike(value) ? camelize(value) : value)
        );
    }
    if (isArray(obj)) {
        return map(obj, camelize);
    }
    return obj;
}
